









import Vue, { PropType } from 'vue'
import { MapPosition } from '@/interfaces/gmap/Map'
import GoogleMapsApiLoader from 'google-maps-api-loader'

export default Vue.extend({
  props: {
    mapConfig: {
      type: Object,
      required: true,
    },
  },
  data(): { google: any; map: any } {
    return {
      google: null,
      map: null,
    }
  },
  async mounted() {
    const googleMapApi = await this.$googleMaps
    this.google = googleMapApi
    this.initializeMap()
  },
  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig)
    },
  },
})
